var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevelUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 15.0625C3.41341 15.0625 3.50322 15.0625 0.46875 15.0625C0.209656 15.0625 0 15.2721 0 15.5312C0 15.7903 0.209656 16 0.46875 16H15.5312C15.7903 16 15.9999 15.7903 15.9999 15.5312C15.9999 15.2721 15.7903 15.0625 15.5312 15.0625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28122 10.375H1.40625C1.14716 10.375 0.9375 10.5847 0.9375 10.8438V14.125H4.74997V10.8438C4.74997 10.5847 4.54031 10.375 4.28122 10.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96861 7.5625H6.15613C5.89703 7.5625 5.68738 7.77216 5.68738 8.03125V14.125H9.43733V8.03125C9.43736 7.77216 9.22771 7.5625 8.96861 7.5625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8626 3.88735L12.5814 0.137381C12.3983 -0.0457124 12.1017 -0.0457124 11.9186 0.137381L8.63731 3.88735C8.50318 4.02147 8.4629 4.22288 8.53569 4.39822C8.608 4.57354 8.77922 4.68754 8.96872 4.68754H10.375V14.125H14.125V4.68754H15.5312C15.7207 4.68754 15.8919 4.57357 15.9642 4.39822C16.037 4.22291 15.9967 4.02147 15.8626 3.88735Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelUp);
export default __webpack_public_path__ + "static/media/level_up.cf14424103b1c8070e9823dadcc0f9c7.svg";
export { ForwardRef as ReactComponent };